import { createStore } from 'vuex'

export default createStore({
	state: {
		loading : true,
		locale : null,
		bikes : null,
		categories : null,
		accessories : null,
		colors : null,
		creationID : /*'w0x3k2u0',//*/window.creation !== null ? window.creation : 'w0x3k2u0',//'w0x3k2u0',//TODO remove me window.creation !== null ? window.creation : null,
		creation: null,
		refer : null,
		client : null,
		
		current_bike : null,
		current_bike_id : null,
		selected_part : null,
		current_color : null,
		selected_measure : '', //TODO remove me
		accessories_data : {},
		
		parts_swiper : null,
		colors_swiper : null,
		
		step : 1,
		alert : null,

		language : window.language !== null ? window.language : 'it'
	},
	getters: {
		customizable_parts(state) {
			if( state.current_bike == null ) return [];
			let parts = state.current_bike.parts.filter(part => (part.customizable == 'true' && part.type != 'cube'));
			parts.sort((a,b)=> {return 1});
			return parts;
		},
		non_customizable_parts(state) {
			if( state.current_bike == null ) return [];
			let parts = state.current_bike.parts.filter(part => (part.customizable == 'false' && part.type != 'cube'));
			parts.sort((a,b)=> {return 1});
			return parts;
		},
		cube_parts(state) {
			if( state.current_bike == null ) return [];
			
			return state.current_bike.parts.filter(part => part.type == 'cube');
		},
		colors_set(state) {
			if(state.current_bike == null) return state.colors;
			
			var sets = JSON.parse(state.current_bike.colors_set);
			return state.colors.filter( c => sets.indexOf(c.type) != -1);
		}
	},
	mutations: {
		setData(state, data) {
			state.loading = false;
			state.locale = data.locale;
			state.bikes = data.bikes;
			state.categories = data.categories;
			state.accessories = data.accessories;
			state.colors = data.colors;
			state.creation = data.creation;
			state.refer = data.refer;
			state.client = data.client;
		},
		selectBike(state, bike_id) {
			state.current_bike_id = bike_id;
		},
		setStep(state, step) {
			state.step = step;
		},
		setLoadingPercentage(state, percentage){
			state.loading_percentage = percentage;
		},
		setCurrentBike(state, bike){
			state.current_bike = bike;
		},
		setPartsSwiper(state, swiper){
			state.parts_swiper = swiper;
		},
		setColorsSwiper(state, swiper){
			state.colors_swiper = swiper;
		},
		setAccessoriesData(state, data){
			state.accessories_data = data;
		},
		setAlert(state, alert){	
			state.alert = alert;
		},
		setSelectedPart(state, part){
			if(part == null) return;
			state.selected_part = part;
			
			if(part.hasOwnProperty('color')){
				var color_index = this.getters.colors_set.findIndex( c => c.color.toLowerCase() == part.color.toLowerCase());
				state.colors_swiper.slideToLoop(color_index);
			}
		},
		setCurrentColor(state, color){
			state.current_color = color;
		},
	},
	actions: {
		
	},
	modules: {
		
	}
})
